<template>
    <ul id="progressbar" class="py-4 pt-15">
        <li v-for="item in value" :key="item.label" :class="{active: item.isActive}">{{item.label}}</li>
    </ul>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                required: true,
                default(){
                    return [];
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>